export function humanise (diff) {
  // The string we're working with to create the representation
  let str = '';
  // Map lengths of `diff` to different time periods
  const values = [['y', 365]];

  // Iterate over the values...
  for (let i=0;i<values.length;i++) {
    const amount = Math.floor(diff / values[i][1]);

    // ... and find the largest time value that fits into the diff
    if (amount >= 1) {
       // If we match, add to the string ('s' is for pluralization)
       str += amount + values[i][0] + (amount > 1 ? 's' : '') + ' ';

       // and subtract from the diff
       diff -= amount * values[i][1];
    }
  }

  return str;
}